import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import { FC, useState } from 'react';
import tw from 'twin.macro';
import {
  ButtonPrimary,
  ButtonSecondary,
} from '../../../libs/design-editor/src/common/button/Button';
//   import { EditorTemplate, useEditor } from '@lidojs/design-editor';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

interface TemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const TemplateModal: FC<TemplateModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  return (
    <Transition appear show={isOpen}>
      <Dialog
        as="div"
        className="relative z-10 focus:outline-none"
        onClose={onClose}
      >
        <div className="fixed inset-0 bg-black/60 dark:bg-[#282B2B]/80" aria-hidden="true" />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center w-full">
            <TransitionChild
              enter="ease-out duration-300"
              enterFrom="opacity-0 transform-[scale(95%)]"
              enterTo="opacity-100 transform-[scale(100%)]"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 transform-[scale(100%)]"
              leaveTo="opacity-0 transform-[scale(95%)]"
            >
              <DialogPanel
                css={{
                  borderRadius: 20,
                  width: '100%',
                  maxWidth: 310,
                  ...tw`backdrop-blur-2xl bg-white  dark:bg-black`,
                  margin: 'auto 20px',
                  '@media (min-width: 768px)': {
                    maxWidth: 400,
                  },
                }}
              >
                <DialogTitle
                  as="div"
                  css={(theme) => ({
                    paddingTop: 32,
                    paddingLeft: 20,
                    paddingRight: 20,
                    textAlign: 'center',
                    marginBottom: 20,
                  })}
                >
                  <h3
                    css={{
                      fontSize: 20,
                      fontWeight: 'bold',
                      textAlign: 'center',
                      ...tw`leading-normal`,
                      '@media (min-width: 768px)': {
                        fontSize: 22,
                        maxWidth: 280,
                        margin: 'auto',
                      },
                    }}
                  >
                    {/* Replace Design with Template? */}
                    {t('page_editor.confirmation.replace_design')}
                  </h3>
                </DialogTitle>

                <div
                  css={(theme) => ({
                    textAlign: 'center',
                    fontSize: 16,
                    padding: '0px 20px',
                  })}
                >
                  {/* Your design has changes. Replace with the selected template? You can undo this if needed. */}
                  {t('page_editor.confirmation.replace_design_desc')}
                </div>

                <div
                  css={(theme) => ({
                    marginTop: 20,
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    padding: '0px 20px',
                    paddingBottom: 20,
                    gap: 8,
                  })}
                >
                  <ButtonPrimary
                    css={(theme) => ({
                      width: '100%',
                      textAlign: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '16px 24px',
                      height: 52,
                      borderRadius: 100,
                    })}
                    isLoading={isLoading}
                    onClick={onConfirm}
                  >
                    {isLoading && (
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-50"
                          fill="#121212"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    )}

                    <span>{t('page_preference.billing.yes_continue')}</span>
                  </ButtonPrimary>

                  <ButtonSecondary
                    css={(theme) => ({
                      width: '100%',
                      textAlign: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '16px 24px',
                      height: 52,
                      borderRadius: 100,
                      borderColor: 'transparent',
                    })}
                    onClick={onClose}
                    disabled={isLoading}
                  >
                    <span>{t('page_editor.confirmation.cancel')}</span>
                  </ButtonSecondary>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default TemplateModal;
